import { getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { CheckoutSessionStatusRS, SessionUpdatePayload } from "@/api/stripe/stripe.models";
import { StripeEmbeddedCheckout } from "@stripe/stripe-js/dist/stripe-js/embedded-checkout";

@Module({
  dynamic: true,
  store,
  name: "rdm-rc-stripe",
  namespaced: true,
})
class ModuleStripe extends VuexModule {
  private clientSecret = "";
  private sessionID = "";
  private sessionStatus = {} as CheckoutSessionStatusRS;
  private checkout: StripeEmbeddedCheckout | null = null;
  private sessionUpdateData = {} as SessionUpdatePayload;
  private sessionPaymentIntent = "";
  private showCheckout = false;
  private stripeError = "";

  //todo create an interface for checkout instance RE-8144
  get Checkout(): StripeEmbeddedCheckout | null {
    return this.checkout;
  }

  get SessionUpdateData(): SessionUpdatePayload {
    return this.sessionUpdateData;
  }

  get SessionStatus(): CheckoutSessionStatusRS {
    return this.sessionStatus;
  }

  get ClientSecret(): string {
    return this.clientSecret;
  }

  get SessionID(): string {
    return this.sessionID;
  }

  get SessionPaymentIntent(): string {
    return this.sessionPaymentIntent;
  }

  get ShowCheckout(): boolean {
    return this.showCheckout;
  }

  get StripeError(): string {
    return this.stripeError;
  }

  @Mutation
  setClientSecret(clientSecret: string) {
    this.clientSecret = clientSecret;
  }
  @Mutation
  setSessionID(sessionID: string) {
    this.sessionID = sessionID;
  }
  @Mutation
  setSessionStatus(status: CheckoutSessionStatusRS) {
    this.sessionStatus = status;
    this.sessionPaymentIntent = status.session?.paymentIntent;
  }
  @Mutation
  setCheckout(checkout: StripeEmbeddedCheckout | null) {
    this.checkout = checkout;
  }
  @Mutation
  setSessionUpdateData(data: SessionUpdatePayload) {
    this.sessionUpdateData = data;
  }
  @Mutation
  setShowCheckout(showCheckout: boolean) {
    this.showCheckout = showCheckout;
  }
  @Mutation
  setStripeError(stripeError: string) {
    this.stripeError = stripeError;
  }

  @Mutation
  reset() {
    this.clientSecret = "";
    this.sessionID = "";
    this.sessionStatus = {} as CheckoutSessionStatusRS;
    if (this.checkout != null) {
      this.checkout.destroy();
    }
    this.checkout = null;
    this.sessionUpdateData = {} as SessionUpdatePayload;
    this.sessionPaymentIntent = "";
    this.showCheckout = false;
    this.stripeError = "";
  }
}

export const stripeModule = getModule(ModuleStripe, store);
